// extracted by mini-css-extract-plugin
export default {"loading":"Preloader_loading__fbnzY","image":"Preloader_image__AH1KC"};